import AddIcon from '@mui/icons-material/Add'
const PlusBox = ({ hover }) => {
  return (
    <AddIcon
      sx={{
        padding: '0.3rem',
        border: '2px dashed',
        borderRadius: '1rem',
        backgroundColor: hover ? 'primary.dark' : 'transparent',
        fontSize: '2.3rem'
      }}
    />
  )
}

export default PlusBox
